import { createSlice } from "@reduxjs/toolkit";

const businessSlice = createSlice({
  name: "business",
  initialState: {
    userBusinesses: [],
    refundRequests: [],
  },
  reducers: {
    addToUserBusinesses: (state, action) => {
      state.userBusinesses = action.payload.data;
    },
    addToRefundRequests: (state, action) => {
      state.refundRequests = action.payload;
    },
  },
});

export const { addToUserBusinesses, addToRefundRequests } =
  businessSlice.actions;
export default businessSlice.reducer;
